import { atom } from 'jotai';

export interface VectorExportTracker {
  toastId: string | number;
  batchId: string;
  projectId: string;
  /** Layer the byproduct is grouped under (matches the source layer's sourceAttachmentId);
   *  drives the `layerByproducts` lookup that resolves the success toast's download. */
  sourceLayerId: string;
  sourceLayerName: string;
  /** 'SHP' | 'DXF' | 'DWG' | 'GPKG' — used in toast copy only. */
  format: string;
}

export const vectorExportTrackingAtom = atom<VectorExportTracker[]>([]);
